import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * T4 — what used tickets actually cost. The headline is the PAYOUT, not face
 * value: the buy-in is comped and the duel is bot-only, so face spent overstates
 * the programme's cost.
 */
export const ArenaOpsTicketsOutcomesResponseSchema = z.object({
  ticketsGranted: z.number().int(),
  ticketsUsed: z.number().int(),
  /**
   * Of `ticketsUsed`, those spent more than once: used, handed back by a
   * cancelled entry, spent again. Only the surviving use is dated below, so this
   * is what says an earlier use exists that the dates do not show.
   */
  ticketsReused: z.number().int(),
  entriesFunded: z.number().int(),
  duelsPlayed: z.number().int(),
  wins: z.number().int(),
  faceSpentUsdt: ArenaOpsUsdtSchema,
  payoutUsdt: ArenaOpsUsdtSchema,
  payoutPerTicketUsedUsdt: ArenaOpsUsdtSchema,
  payoutPerTicketGrantedUsdt: ArenaOpsUsdtSchema,
  /**
   * Newest first — `lastUsedAt` descending, campaign name breaking ties.
   *
   * Both dates are the SURVIVING use of each ticket: the latest `USE` movement,
   * the one that left the ticket `USED` and funded the entry this campaign row
   * counts. A ticket has one such use, so the dates stay one-to-one with
   * `ticketsUsed` — see `ticketsReused` for the discarded earlier ones.
   */
  byCampaign: z.array(
    z.object({
      campaignName: z.string(),
      ticketsUsed: z.number().int(),
      payoutUsdt: ArenaOpsUsdtSchema,
      firstUsedAt: z.iso.datetime(),
      lastUsedAt: z.iso.datetime(),
    }),
  ),
});
export type ArenaOpsTicketsOutcomesResponse = z.infer<typeof ArenaOpsTicketsOutcomesResponseSchema>;
